<template>
  <div>
    <div class="panel panel-default summaryPanel">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-10">
            <h4>
              <slot name="title">something</slot>
            </h4>
          </div>

          <div class="col-xs-2" style="text-align: right">
            <a class="accordion-toggle" data-toggle="collapse" :href="anchorURL"></a>
          </div>
        </div>
      </div>
      <div :id="anchor" class="panel-collapse collapse" :class="collapsed">
        <div class="panel-body">
          <slot name="body">nothing</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['anchor', 'initallyOpen'],
  computed: {
    anchorURL() {
      if (this.anchor !== '') {
        return `#${this.anchor}`;
      }
      return '';
    },
    collapsed() {
      if (this.initallyOpen) {
        return 'in';
      }
      return '';
    },
  },
};
</script>

<style></style>
